import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import MainBlockLayout from '../../components/MainBlockLayout';
import './Vacancies.css';

// ============================================================
// HOW TO ADD A VACANCY: add one object to the list below.
//   title:   job title (shown as is)
//   tags:    optional small labels, e.g. ['Part-time', 'Amersham']
//   summary: optional one or two sentences
//   link:    application / details page
// To remove a vacancy, delete its object. An empty list shows a
// "no vacancies" message automatically.
// ============================================================
const VACANCIES = [
  {
    title: 'Teacher',
    tags: [],
    summary: '',
    link: 'https://cleverstaff.net/i/vacancy-uDddw4',
  },
];

function MainBlock() {
  return (
    <div className="vacancyPage">
      <p className="vacancyIntro"><Trans i18nKey="introduces current vacancies" /></p>

      {VACANCIES.length > 0 ? (
        <div className="vacancyList">
          {VACANCIES.map((vacancy) => (
            <div className="vacancyCard" key={vacancy.link}>
              <div>
                <h4 className="vacancyTitle">{vacancy.title}</h4>
                {vacancy.tags.length > 0 && (
                  <div className="vacancyMeta">
                    {vacancy.tags.map((tag) => <span key={tag} className="vacancyTag">{tag}</span>)}
                  </div>
                )}
                {vacancy.summary && <p className="vacancySummary">{vacancy.summary}</p>}
              </div>
              <a className="vacancyApply" href={vacancy.link} target="_blank" rel="noreferrer">
                <Trans i18nKey="vacancy_apply" />
              </a>
            </div>
          ))}
        </div>
      ) : (
        <div className="vacancyEmpty">
          <h4><Trans i18nKey="vacancy_none_title" /></h4>
          <p><Trans i18nKey="vacancy_none_text" /></p>
        </div>
      )}

      {/* Always visible, so candidates can send a speculative application */}
      <div className="vacancyEmpty">
        <p><Trans i18nKey="vacancy_speculative" /></p>
        <Link className="vacancyContact" to="/contact-us"><Trans i18nKey="Contact Us" /></Link>
      </div>
    </div>
  );
}

export default MainBlockLayout(MainBlock);
